
function AboutPage() {
  return (
    <div className="about-page">
      <div className="about-container">
        <span className="about-badge">
          درباره ما
        </span>

<div className="about-quote-section">

  <div className="about-quote-icon">
    ✦
  </div>
  <h2>
    یادگیری فقط یک مهارت نیست،
    بلکه مسیری برای ساختن آینده‌ای بهتر است.
  </h2>

  <p>
    ما باور داریم آموزش زمانی ارزشمند می‌شود
    که بتواند الهام‌بخش رشد، خلاقیت و تغییر واقعی باشد.
  </p>

</div>

        <p>
         ما فعالیت خود را با هدف ایجاد یک فضای آموزشی مدرن، کاربردی و قابل اعتماد آغاز کردیم؛ جایی که یادگیری فقط محدود به تماشای چند ویدیو یا مطالعه چند مقاله نباشد، بلکه به یک مسیر واقعی برای رشد فردی و حرفه‌ای تبدیل شود. باور ما این است که آموزش زمانی ارزشمند است که بتواند تغییری ملموس در زندگی افراد ایجاد کند.

در دنیایی که هر روز فناوری با سرعت بیشتری در حال پیشرفت است، دسترسی به آموزش باکیفیت بیش از هر زمان دیگری اهمیت پیدا کرده است. ما تلاش کرده‌ایم محیطی فراهم کنیم که کاربران بتوانند بدون پیچیدگی و سردرگمی، به محتوای آموزشی استاندارد و به‌روز دسترسی داشته باشند و مسیر یادگیری خود را با آرامش ادامه دهند.

تمرکز اصلی ما بر تولید محتوایی است که علاوه بر کیفیت علمی، از نظر تجربه کاربری نیز در سطح بالایی قرار داشته باشد. به همین دلیل در طراحی این پلتفرم، سادگی، سرعت، زیبایی و دسترسی آسان در اولویت قرار گرفته است تا کاربران بتوانند بدون حواس‌پرتی روی یادگیری تمرکز کنند.

ما اعتقاد داریم یادگیری یک مسیر همیشگی است، نه یک مقصد کوتاه‌مدت. به همین خاطر تلاش می‌کنیم محتوای آموزشی خود را به‌صورت مداوم به‌روزرسانی کنیم و متناسب با نیازهای جدید کاربران و تغییرات دنیای تکنولوژی توسعه دهیم.

یکی از مهم‌ترین اهداف ما ایجاد حس اعتماد و همراهی میان کاربران و مجموعه است. ما فقط یک وب‌سایت آموزشی نیستیم؛ بلکه سعی داریم به جامعه‌ای از افراد علاقه‌مند به رشد، پیشرفت و یادگیری تبدیل شویم که بتوانند تجربیات و دانش خود را با یکدیگر به اشتراک بگذارند.

در مسیر توسعه این مجموعه، همواره تلاش کرده‌ایم از جدیدترین استانداردهای طراحی و فناوری استفاده کنیم تا تجربه‌ای سریع، امن و حرفه‌ای برای کاربران فراهم شود. ما باور داریم کیفیت فنی یک پلتفرم آموزشی به اندازه کیفیت محتوای آن اهمیت دارد.

ما به آینده آموزش دیجیتال نگاه جدی و بلندمدتی داریم. هدف ما این است که بستری ایجاد کنیم که نه‌تنها برای امروز، بلکه برای سال‌های آینده نیز پاسخگوی نیاز کاربران باشد و بتواند همراه مطمئنی در مسیر یادگیری و پیشرفت آن‌ها باقی بماند.

پشتیبانی و ارتباط نزدیک با کاربران بخش مهمی از فلسفه کاری ماست. ما همواره تلاش می‌کنیم نظرات، پیشنهادها و بازخوردهای کاربران را با دقت بررسی کنیم و از آن‌ها برای بهبود خدمات و تجربه کاربری استفاده کنیم.

این مجموعه با عشق به یادگیری، توسعه فردی و پیشرفت مداوم شکل گرفته است. هر بخش از این پلتفرم با دقت طراحی شده تا کاربران بتوانند در فضایی حرفه‌ای، آرام و الهام‌بخش مسیر آموزشی خود را ادامه دهند.

ما همچنان در ابتدای مسیر هستیم و باور داریم بهترین اتفاقات هنوز در راه‌اند. از اینکه بخشی از این مسیر هستید و ما را همراهی می‌کنید صمیمانه سپاسگزاریم و امیدواریم بتوانیم تجربه‌ای ارزشمند، متفاوت و ماندگار برای شما ایجاد کنیم.


        </p>
        <div className="about-features">

  <div className="about-feature-card">
    <div className="about-feature-icon">⚡</div>

    <h3>آموزش کاربردی</h3>

    <p>
      تمرکز ما روی آموزش‌هایی است که
      در دنیای واقعی قابل استفاده باشند
      و فقط به مباحث تئوری محدود نشوند.
    </p>
  </div>

  <div className="about-feature-card">
    <div className="about-feature-icon">🎯</div>

    <h3>مسیر یادگیری هدفمند</h3>

    <p>
      محتوای آموزشی به‌گونه‌ای طراحی شده
      که کاربران بتوانند قدم‌به‌قدم و بدون
      سردرگمی پیشرفت کنند.
    </p>
  </div>

  <div className="about-feature-card">
    <div className="about-feature-icon">🚀</div>

    <h3>توسعه مداوم</h3>

    <p>
      ما همواره در حال بهبود پلتفرم،
      طراحی تجربه کاربری و کیفیت
      آموزش‌ها هستیم.
    </p>
  </div>

</div>
<div className="about-stats">

  <div className="about-stat-box">
    <strong>1200+</strong>
    <span>دانشجوی فعال</span>
  </div>

  <div className="about-stat-box">
    <strong>85+</strong>
    <span>محتوای آموزشی</span>
  </div>

  <div className="about-stat-box">
    <strong>24/7</strong>
    <span>پشتیبانی کاربران</span>
  </div>

  <div className="about-stat-box">
    <strong>98%</strong>
    <span>رضایت کاربران</span>
  </div>

</div>

      </div>
    </div>
  );
}

export default AboutPage;